import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { createContext, useContext } from 'react';
import { PaginationUpdateEvent } from 'ui/paginationFooter';
import { NestedTableNodeTree } from 'ui/treeView';
import noop from 'utils/noop';
import { CSVSnippetObj, Info, SnippetsTableModes } from '../types';

export type SnippetsContextState = {
  mode: SnippetsTableModes;
  tableData: NestedTableNodeTree[];
  csvData: CSVSnippetObj[];
  searchTerm: string;
  sortBy: string;
  sortDirection: SORT_DIRECTIONS;
  pagination: Info;
  hasError: boolean;
  isLoading: boolean;
  isExpanded: boolean;
  showCampaigns: boolean;
  handleSearch: (searchTerm: string) => void;
  setShowCampaigns: (val: boolean) => void;
  handleSort: (col: string) => void;
  handlePageChange: (props: PaginationUpdateEvent) => void;
  updateIsExpanded: () => void;
  startTime?: string;
};

export const DEFAULT_SNIPPETS_STATE = {
  mode: SnippetsTableModes.CampaignAnalytics,
  tableData: [],
  csvData: [],
  searchTerm: '',
  sortBy: 'TotalSent',
  sortDirection: SORT_DIRECTIONS.DESCENDING,
  pagination: {
    limit: 10,
    offset: 0,
    count: 0,
    page: 1,
  },
  hasError: false,
  isLoading: false,
  isExpanded: false,
  showCampaigns: false,
  setShowCampaigns: noop,
  handleSearch: noop,
  handleSort: noop,
  handlePageChange: noop,
  updateIsExpanded: noop,
};

export const SnippetsContext = createContext<SnippetsContextState>(DEFAULT_SNIPPETS_STATE);

export const useSnippetsContext = () => useContext(SnippetsContext);
